import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dcbf8f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row my-3 justify-content-center" }
const _hoisted_4 = { class: "col-sm-12 col-md-8 offset-md-1 col-lg-6 offset-lg-1 col-sm-12 offset-sm-0 card" }
const _hoisted_5 = { class: "row justify-content-end mx-md-0 mx-1 mb-5" }
const _hoisted_6 = { class: "col-md-12 col-12 col-lg-12" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Shareholder Corporate type", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian Domestic Company", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "ASIC registered Non-Australian Company", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Non-Australian Company", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-lg-4 col-md-4 px-1" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
  }, " Proceed ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shareholderbasic = _resolveComponent("shareholderbasic")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_shareholderbasic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.in_verification==0)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              method: "POST",
              action: "/",
              class: "my-1 p-2",
              onSubmit: _ctx.app_proceed
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _hoisted_8,
                          _createVNode(_component_Field, {
                            style: {"font-size":"18px!important"},
                            modelValue: _ctx.company_type,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company_type) = $event)),
                            id: "company_type",
                            class: "form-control",
                            name: "company_type",
                            as: "select",
                            rules: _ctx.selectField
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9,
                              _hoisted_10,
                              _hoisted_11,
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "company_type"
                          })
                        ])
                      ]),
                      _hoisted_13
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}